import { ErrorResponse } from 'src/app/models/error/error-response.model';

export interface ApiErrorState {
  errorResponse?: ErrorResponse;
}

export const initialState: ApiErrorState = {
  errorResponse: undefined,
};
